import { RootState } from '../store';

export const selectDateData = (state: RootState) => state.date;
